module.exports = __webpack_public_path__ + "img/lowlow_highhighalarm_pumpstation.9e74609f.svg";